import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08a166ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "svg-inline",
  height: "20",
  viewBox: "0 0 21 20",
  width: "21",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M9.75 5H11.75V7H9.75V5ZM10.75 15C11.3 15 11.75 14.55 11.75 14V10C11.75 9.45 11.3 9 10.75 9C10.2 9 9.75 9.45 9.75 10V14C9.75 14.55 10.2 15 10.75 15ZM10.75 0C5.23 0 0.75 4.48 0.75 10C0.75 15.52 5.23 20 10.75 20C16.27 20 20.75 15.52 20.75 10C20.75 4.48 16.27 0 10.75 0ZM10.75 18C6.34 18 2.75 14.41 2.75 10C2.75 5.59 6.34 2 10.75 2C15.16 2 18.75 5.59 18.75 10C18.75 14.41 15.16 18 10.75 18Z",
  fill: "currentColor"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}